import { Directive, HostListener, inject, Input } from '@angular/core';
import { PLATFORM_TOKEN, PlatformProvider } from '../tokens';
import { CoordinatesModel } from '../interfaces';

@Directive({
  standalone: true,
  selector: '[navigate]'
})
export class NavigateDirective {
  @Input('navigate') coordinates!: CoordinatesModel;

  private platform: PlatformProvider = inject(PLATFORM_TOKEN);

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.stopImmediatePropagation();

    this.openNavigate();
  }

  private openNavigate(): void {
    const { latitude, longitude } = this.coordinates;

    if (this.platform.isAndroid) {
      window.open(`google.navigation:q=${latitude},${longitude}`, '_blank');
      return;
    }

    window.open(`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`, '_blank');
  }
}
